import React from 'react';
import PropsType from 'prop-types';

import { recentMeetColumns } from 'config/admin/athleteDashboard';
import { recentMeetData } from 'services/admin/AthleteDashboardService';

import AdminDataTable from 'components/admin/AdminDataTable';
import useGroupLabels from 'hooks/useGroupLabels';

const AthleteRecentMeet = ({ recentMeet, clubId, openPopup }) => {
  // The highest group number the club places by age: a result above it is an adult's, and links to the event
  // view, not the age view. See utils/groupLabel.js.
  const { oldestPlacedByAge } = useGroupLabels(clubId);

  if (!recentMeet?.results?.length) return null;

  const formatDate = (dateString) => {
    // Convert to "June 09, 25" format
    const dateObj = new Date(dateString);
    const month = dateObj.toLocaleDateString('en-US', { month: 'long' });
    const day = dateObj.getDate().toString().padStart(2, '0');
    const year = dateObj.getFullYear().toString().slice(-2);
    return `${month} ${day}, ${year}`;
  };

  return (
    <>
      <div style={{ marginBottom: '20px', marginTop: '20px' }}>
        <h2
          className="heading2"
          style={{
            margin: '0 0 8px 0',
            fontSize: '20px',
            fontWeight: '600',
            color: '#212529',
          }}
        >
          Most Recent Meet
        </h2>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            flexWrap: 'wrap',
            fontSize: '16px',
            color: '#495057',
          }}
        >
          <span style={{ fontWeight: '500' }}>{recentMeet.meetName}</span>
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: '#6c757d',
              fontSize: '14px',
            }}
          >
            <span style={{ fontSize: '16px' }}>📅</span>
            <span style={{ fontWeight: '500' }}>
              {formatDate(recentMeet.meetDate)}
            </span>
          </span>
        </div>
      </div>

      <AdminDataTable
        borderType="full"
        isAddedFeatures={false}
        columns={recentMeetColumns}
        data={recentMeetData(
          recentMeet,
          clubId,
          openPopup,
          oldestPlacedByAge
        )}
        searchInputPlaceholder=""
        headStyle={{
          gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr 1.2fr', // 7 columns with flexible sizing
          background: '#f1f1f2',
        }}
        rowStyle={{
          gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 1fr 1.2fr', // 7 columns with flexible sizing
        }}
      />
    </>
  );
};

AthleteRecentMeet.propTypes = {
  recentMeet: PropsType.shape({
    meetDate: PropsType.string,
    meetName: PropsType.string,
    meetId: PropsType.string,
    results: PropsType.array,
  }),
  clubId: PropsType.string,
  openPopup: PropsType.func.isRequired,
};

export default AthleteRecentMeet;
